import React, { useState } from 'react';
import { IonToast } from '@ionic/react';
import EventBus from '../services/EventBus';

interface Props {}

const PWAToast: React.FC<Props> = (props) => {
  const [showToast, setShowToast] = useState(false);

  EventBus.pwaUpdate.on((registration) => {
    setShowToast(true);
  });

  return (
    <IonToast
      color={'primary'}
      isOpen={showToast}
      onDidDismiss={() => setShowToast(false)}
      message="Une nouvelle version de l'application est disponible."
      buttons={[
        {
          side: 'end',
          icon: 'refresh-outline',
          text: 'Mettre à jour',
          handler: () => {
            caches.keys().then(function (names) {
              for (let name of names) caches.delete(name);
            });
            window.location.reload();
          }
        }
      ]}
    />
  );
};

export default PWAToast;
